<script setup lang="ts">
import { computed } from 'vue';
import { LineModel } from '../../../core/line_model';

const props = defineProps<{ line: LineModel }>();
const line = computed(() => { return props.line; });
</script>

<template>
    <p v-if="line.description">{{ line.description }}</p>
    <h4 v-if="line.videos.length > 0">Videos</h4>
    <video controls v-for="video of line.videos" :src="video" class="video"></video>
</template>
